import Vue from 'vue'
import { getDefaultDate } from '@modules/events/domain/utils/date'

const isProd = process.env.NODE_ENV === 'production'

export default {
  namespaced: true,
  state: {
    listEvents: [],
    calendarEvents: [],
    modalForm: null,
    adsBanner: null,
    filter: [],
    linkArchive: '#',
    listDecision: [],
    currentView: null,
    events: [],

    popover: {
      isOpened: false,
      style: '',
      events: [],
    },
    isLoading: true,
  },
  mutations: {
    setPopover(state, data) {
      state.popover = data
    },
    setCalendarEvents(state, data = []) {
      state.calendarEvents = data.map(item => ({
        id: item.id,
        title: item.title,
        start: item.dateStart,
        end: item.dateEnd,
        vendors: item.vendors,
        mark: item.mark,
        link: item.link,
        endReg: item.dateEndReg,
        availableReg: item.availableReg,
        eventArea: item.eventArea,
        externalAreaUrl: item.externalAreaUrl,
        color: '#00b0bd',
        timed: false,
      }))
    },
    setListEvents(state, data = []) {
      state.listEvents = data
    },
    setIsLoading(state, isLoading) {
      state.isLoading = isLoading
    },
  },
  getters: {
    getEvents(state) {
      return state.events
    },
    getCalendarEvents(state) {
      return state.calendarEvents
    },
    getListEvents(state) {
      return state.listEvents
    },
    isModalForm(state) {
      return Boolean(state.modalForm)
    },
  },
  actions: {
    async getEvents({ commit }, params) {
      commit('setIsLoading', true)

      const url = isProd ? '/api/templates/events-list' : '/api/events/getEventsList.json'

      try {
        const { data } = await Vue.http.get(url, { params })

        return { success: true, data }
      } catch (error) {
        return { success: false, data: [] }
      } finally {
        commit('setIsLoading', false)
      }
    },
    async getCalendarEvents({ dispatch, commit }, params) {
      commit('setCalendarEvents', [])
      const { success, data } = await dispatch('getEvents', params)

      if (!success) return

      commit('setCalendarEvents', data.events)
    },
    async getListEvents({ dispatch, commit }, params) {
      commit('setListEvents', [])

      const { success, data } = await dispatch('getEvents', params)

      if (!success) return

      commit('setListEvents', data.events)
    },
    setPopoverOpened({ commit }, { style, events }) {
      commit('setPopover', {
        isOpened: true,
        events,
        style,
      })
    },
    setPopoverClosed({ commit }) {
      commit('setPopover', {
        isOpened: false,
        events: [],
        style: '',
      })
    },
  },
}



// WEBPACK FOOTER //
// ./src/legacy/store/modules/events.js